import regeneratorRuntime from "regenerator-runtime";
import map from "lodash/map";
import forEach from "lodash/forEach";
import isPlainObject from "lodash/isPlainObject";
import isFunction from "lodash/isFunction";
import isArray from "lodash/isArray";
import sprintf from "sprintf";
import "bootstrap-select";
import "bootstrap-switch";
import "bootstrap";
import "jquery.placeholder";
import $script from "scriptjs";
import loginButton from "general/components/login.button";
import messageModal from "general/components/messageModal";
import storage from "general/poly/storage";
import cookies from "general/cookies";
import "general/intercom";
import localSession from "general/localSession";
import { setSourceHeader } from "general/source";

$.fn.selectpicker.defaults = {
    size: 4
};
const endpointWithReturnFields = (endpoint) => {
    const el = document.querySelector(`#endpoint-return-fields span[data-endpoint="${endpoint}"]`);
    if (el) {
        return `${endpoint}?return_fields=${el.textContent}`;
    }
    return endpoint;
};

const GA_BATCH_ENDPOINT = 'https://www.google-analytics.com/batch';
var apiEndPointPattern = new RegExp("/api(?:/v1)?/([^/]+)/"),
    startSession = function (endpoint, data, callbacks) {
        function success(data, textStatus, jqXHR) {
            const [, setUser] = localSession.user;
            const [, setWorkplace] = localSession.workplace;
            const user = setUser(data);
            setWorkplace(user.last_workplace_visited);

            loginButton.refresh();
            general.registerUserActivity("Login", "Activity", user.username, 0);
        }

        if (!isPlainObject(callbacks)) callbacks = {};
        if (isFunction(callbacks[201])) callbacks[201] = [callbacks[201]];
        if (!isArray(callbacks[201])) callbacks[201] = [];
        callbacks[201].unshift(success);

        general.callBFF(`/session/${endpoint}/`, "POST", data, callbacks, null, null, false);
    },
    general = {
        storage: storage.localStorage,
        googleAnalyticsAvailable: function () {
            return typeof(ga) != "undefined";
        },
        user: $.parseJSON(storage.localStorage.getItem("user")),
        requiresLogin: function (jqXHR, textStatus, errorThrown) {
            if (!general.user) {
                $("#login-message").addClass("text-error").html("You need to be logged in to use this functionality.");
                //TODO: Re-enable once we have replace the bootstrap modal
                $("#login-modal").modal("show");
            } else {
                /*
                    requiresLogin is called if the response's status is 401 or 405 (cf statusCodesDefaultHandlerMap).
                    If 401 is returned and if the error code is related to user authentication/authorisation, it will log the user out.
                */
                let endSession = false;
                if (jqXHR.status === 401) {
                    const [code] = Object.entries(jqXHR.responseJSON).map(([, obj]) =>
                        obj.authorization ? obj.authorization.code : obj
                    );
                    endSession = [
                        "user_authentication",
                        "user_authorization",
                        "django_authorization",
                        "unauthenticated_user",
                        "appointment_user_authorisation",
                    ].includes(code);
                }
                general.modalMessage(
                    "You do not have permission to perform that action",
                    "text-error",
                    () => endSession && general.endSession(),
                    errorThrown
                );
            }
        },
        serverError: function (jqXHR, textStatus, errorThrown) {
            general.modalMessage("Server error. Try again later.", "text-error", null, errorThrown);
        },
        gatewayTimeout: function (jqXHR, textStatus, errorThrown) {
            general.modalMessage(
                jqXHR.responseJSON.message,
                "text-error",
                null,
                errorThrown,
            );
        },
        forbidden: function(jqXHR, textStatus, errorThrown) {
            general.modalMessage(
                "You do not have permissions to perform that action and the changes have not been saved.",
                "forbidden",
                null,
                errorThrown
            );
        },
        /**
         * Call through to the RecoMed API using the API authentication details asociated with the
         * currently logged in user, if any.
         *
         * @param {string} endpoint
         * @param {string} method
         * @param {object} data
         * @param {object|null} [callbacks]
         * @param {function|null} [genericSuccessCallbacks]
         * @param {function|null} [genericFailureCallbacks]
         * @param {boolean|null} [async=true]
         * @param {boolean} [cache=false]
         * @param {boolean} [disableGenericErrorHandling=false]
         * @param {object} [headers]
         * @returns {Deferred}
         */
        callBFF: function (endpoint, method, data, callbacks, genericSuccessCallbacks, genericFailureCallbacks, async=true, cache=false, disableGenericErrorHandling=false, headers) {
            return general.callApi(
                endpoint,
                method,
                data,
                callbacks,
                genericSuccessCallbacks,
                genericFailureCallbacks,
                async,
                cache,
                disableGenericErrorHandling,
                headers,
                true // bff flag
            );
        },
        callApi: function (endpoint, method, data, callbacks, genericSuccessCallbacks, genericFailureCallbacks, async=true, cache=false, disableGenericErrorHandling=false, headers, bff=false) {
            endpoint = endpointWithReturnFields(endpoint);
            var url = bff ? endpoint : (endpoint.indexOf("/api/") == - 1 ? "/api/" : "") + endpoint,
                data = isPlainObject(data) ? data : {},
                headers = isPlainObject(headers) ? headers : {},
                statusCodesDefaultHandlerMap= {
                    401: general.requiresLogin,
                    403: general.forbidden,
                    405: general.requiresLogin,
                    500: general.serverError,
                    503: general.serverError,
                    504: general.gatewayTimeout
                };
            if (isFunction(genericSuccessCallbacks)) genericSuccessCallbacks = [genericSuccessCallbacks];
            if (isFunction(genericFailureCallbacks)) genericFailureCallbacks = [genericFailureCallbacks];

            if (!isPlainObject(callbacks)) callbacks = {};
            forEach(statusCodesDefaultHandlerMap, function (handler, status_code) {
                if (!callbacks[status_code]) callbacks[status_code] = handler;
            });

            const apiAuth = sessionStorage.getItem('api_auth');
            if (apiAuth) {
                headers['X-API-AUTH'] = apiAuth
            }

            headers = setSourceHeader(headers);

            // send request via AJAX
            return $.ajax({
                url: url,
                headers: headers,
                type: method,
                async: async,
                data: method == "GET" ? Object.keys(data).length > 0 ? data : null : JSON.stringify(data),
                cache: false,
                dataType: "json",
                contentType: "application/json; charset=UTF-8",
                success: isArray(genericSuccessCallbacks) ? genericSuccessCallbacks : function () {
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    const result = jqXHR.responseJSON;

                    if (isArray(genericFailureCallbacks)) {
                        forEach(genericFailureCallbacks, callback => {
                            callback(jqXHR, textStatus, errorThrown);
                        });
                    }
                    if (!disableGenericErrorHandling && !callbacks[jqXHR.status]) {
                        var message = errorThrown,
                            messageTitle = null;
                        if (result) {
                            var endpointMatch = this.url.match(apiEndPointPattern),
                                endpoint = endpointMatch == null ? null : endpointMatch.pop();
                            if (endpoint && result.hasOwnProperty(endpoint)) {
                                messageTitle = "Validation Error";
                                message = sprintf("The following validation errors occurred:<br><br>%s",
                                    map(result[endpoint], function (errorMessage, errorField) {
                                        if (typeof errorMessage === "string") {
                                            return errorMessage;
                                        } else if (typeof errorMessage === "object" && errorMessage.code && errorMessage.message) {
                                            return errorMessage.message;
                                        } else {
                                            return JSON.stringify(errorMessage)
                                        }
                                    }).join("<br>")
                                );
                            }
                        }
                        general.modalMessage(message, "error", null, messageTitle);
                    }
                    if (result && "__push_message" in result) {
                        let message = result;
                        let path = new Array(...result["__push_message"]);
                        while (path.length > 0) {
                            let key = path.shift();
                            message = message[key];
                        }
                        general.modalMessage(message, "error");
                    }
                },
                statusCode: callbacks,
            });
        },
        getStaticPath: function (relativePath) {
            return globalConfig.staticRoot + "/" + relativePath;
        },
        getProfilePicURL: function (relativePath) {
            return globalConfig.profilePicURL + "/" + relativePath;
        },
        startSessionWithToken: function (apiTokenChain, callbacks) {
            startSession("token_login", {
                domain: "User",
                api_token_chain: apiTokenChain,
            }, callbacks);
        },
        startSession: function (username, password, callbacks) {
            if (username) storage.localStorage.setItem("tmp_email", username);
            startSession("login", {
                username: username,
                password: password,
            }, callbacks);
        },
        /**
         *
         * @param {Function} [callback]
         */
        endSession: function (callback) {
            var callback = isFunction(callback) ? callback : function () {
                    localSession.clear();
                    window.location = "/signout";
                },
                userEmail = storage.localStorage.getItem("tmp_email");
            const [getUser] = localSession.user;
            const user = getUser();
            if (user) {
                general.registerUserActivity("Logout", "Activity", user.username, 0);
            }
            window.intercomSettings = null;
            if(window.Intercom) {
                Intercom('shutdown');
            }
            if (userEmail) storage.localStorage.setItem("tmp_email", userEmail);
            return callback();
        },
        modalMessage: function (messageText, messageClass, onClose, messageTitle) {
            if (document.querySelector("[data-disable-modal]") === null) {
                messageModal.displayMessage(messageText, messageClass, onClose, messageTitle);
            }
        },
        /**
         * Submits user activity to Intercom.
         * @param name The event name.
         * @param [delay=0] The exponent used to calculate the delay
         * before actually calling Intercom: 2^(delay) seconds. If
         * Intercom has not been loaded yet, this function backs of
         * exponentially by incrementing delay and recursing.
         */
        logIntercomEvent: function logIntercomEvent(name, delay) {
            var delay = delay ? delay: 0;
            if (window.Intercom) {
                Intercom("trackEvent", name);
            } else {
                setTimeout(function () {
                    logIntercomEvent(name, delay+1)
                }, Math.pow(2, delay) * 1000);
            }
        },
        /**
         * Submits user activity to Google Analytics and the RecoMed Clicks model.
         *
         * @param activityType
         * @param activity
         * @param [activityLabel] Optional. Defaults to auto-generated value based on user type, name and ID.
         * @param [activityValue=1] Optional. Defaults to 1.
         */
        registerUserActivity: function (activityType, activity, activityLabel, activityValue) {
            activityValue = activityValue ? activityValue : 1;
            activityValue = typeof activityValue == "number" ? activityValue : 1;
            let pageData = $("#page-data"),
                appName = pageData.data("app-name") || null,
                instance = pageData.data("instance-name") || null,
                remoteAddress = pageData.data("remote-address") || null;
            general.callApi("event/", "POST", {
                category: activityType,
                activity: activity,
                label: activityLabel,
                value: activityValue,
                app: appName,
                instance: instance,
                source: remoteAddress,
            }, null, null, null, true, false, true);

            if (general.googleAnalyticsAvailable()) {
                ga("send", "event", activityType, activity, activityLabel, activityValue);
            }
            general.logIntercomEvent(activityType + "-" + activity);
        },

        postGABatchHits: function(data) {
            var trackingId = $("#page-data").data("ga-tracking-id"),
                batchPayload = '';

            if (!$("#debug-mode").length && general.googleAnalyticsAvailable() && trackingId) {
                $script(["https://www.google-analytics.com/analytics.js"], function () {
                    ga(function(tracker) {
                        var clientId = tracker.get('clientId');
                        forEach(data, function(hit) {
                            hit.tid = trackingId;
                            hit.cid = clientId;
                            batchPayload = batchPayload + $.param(hit) + '\n';
                        });
                        return $.ajax({
                            url: GA_BATCH_ENDPOINT,
                            method: 'POST',
                            data: batchPayload,
                            contentType: 'text/plain',
                            cache: false,
                            error: function(jqXHR, textStatus, errorThrown) {
                                console.error('Failed to send search results analytics:', errorThrown);
                            }
                        });
                    });
                });
            }
        }
    };




/**
 * On-Ready code common to ALL pages within the site
 */
$(document).ready(function () {
    const [getUser, setUser] = localSession.user;
    const user = setUser({
        ...getUser(),
        is_logged_in: document.querySelector("#is-logged-in").dataset.value === "true"
    });

    if (!cookies.get('authorised') || (user && user.api_key) || !user.is_logged_in) {
        localSession.clear();
        window.intercomSettings = null;
        if(window.Intercom) {
            Intercom('shutdown');
        }
    }

    if (localSession.hasInvalidUser(user)) {
        localSession.clear();
        window.location = "/signout";
    }

    loginButton.refresh();

    // Use Bootstrap-Select plugin to override the default ugly selects
    $("select:not(.no-select)").selectpicker();

    // Use Bootstrap-Switch plugin to override default checkboxes
    $.fn.bootstrapSwitch.defaults.state = false;
    $("input[type=checkbox]:not(.no-switch)").bootstrapSwitch();

    // Use jQuery Placeholder plugin to ensure placeholders work on all browsers
    $('input, textarea').placeholder();

    // Google Analytics
    var pageData = $("#page-data"),
        resultMetaData = $('#results-metadata');
    if (!pageData.data('debug') && general.googleAnalyticsAvailable()) {
        ga("set", "dimension1", $("#ga-page-type").data("ga-page-type") || "Miscellaneous");
        ga('send', 'pageview');
    }

    // cookie consent
    if (cookies.get("cookieConsentOpt") != "true") {
        const div = document.querySelector('div[data-cookie-consent]');
        div.style.display = 'flex';
        div.querySelector('button').addEventListener('click', () => {
            div.style.display = 'none';
            cookies.set("cookieConsentOpt", "true", 30);
        });
    }
});

export default general;
